export default "__VITE_PUBLIC_ASSET__ba40a993__"